import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { appReactMemo } from 'hocs';
import { SESSION_CONFIG } from 'queries/session/constants';
import { getLastActivity } from 'queries/session/utils';

const getRemainingSeconds = () =>
  Math.max(
    0,
    Math.ceil((getLastActivity() + SESSION_CONFIG.IDLE_TIMEOUT - Date.now()) / 1000),
  );

const IdleCountdown = (): React.ReactElement => {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(getRemainingSeconds);

  useEffect(() => {
    const intervalId = setInterval(
      () => setSeconds(getRemainingSeconds()),
      SESSION_CONFIG.IDLE_TICK,
    );

    return () => clearInterval(intervalId);
  }, []);

  return <>{t('session.idle.warningMessage', { seconds })}</>;
};

export default appReactMemo(IdleCountdown);
